'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback, useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSearchBox } from 'react-instantsearch';
import { debounce } from 'lodash';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import IconSearch from 'components/icons/IconSearch';
import { colorGrayLight2 } from 'styles/layout/colors';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';
const CategorySearchBox = t0 => {
  const $ = _c(20);
  const {
    pageName: t1
  } = t0;
  const pageName = t1 === undefined ? "" : t1;
  const {
    refine,
    query
  } = useSearchBox();
  const {
    onSearchQueryChange,
    searchQuery
  } = useAdvancedSearchContext();
  const [inputValue, setInputValue] = useState(query ?? "");
  const latestQueryRef = useRef(query ?? "");
  let t2;
  let t3;
  if ($[0] !== query) {
    t2 = () => {
      const nextQuery = query ?? "";
      latestQueryRef.current = nextQuery;
      setInputValue(nextQuery);
    };
    t3 = [query];
    $[0] = query;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[3] !== refine || $[4] !== searchQuery) {
    t4 = () => {
      const nextSearchQuery = searchQuery ?? "";
      if (nextSearchQuery === latestQueryRef.current) {
        return;
      }
      latestQueryRef.current = nextSearchQuery;
      setInputValue(nextSearchQuery);
      refine(nextSearchQuery);
    };
    t5 = [searchQuery, refine];
    $[3] = refine;
    $[4] = searchQuery;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] !== onSearchQueryChange) {
    t6 = debounce(value => onSearchQueryChange?.(value), 300);
    $[7] = onSearchQueryChange;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const debouncedSearchChange = t6;
  let t7;
  let t8;
  if ($[9] !== debouncedSearchChange) {
    t7 = () => () => debouncedSearchChange.cancel();
    t8 = [debouncedSearchChange];
    $[9] = debouncedSearchChange;
    $[10] = t7;
    $[11] = t8;
  } else {
    t7 = $[10];
    t8 = $[11];
  }
  useEffect(t7, t8);
  let t9;
  if ($[12] !== debouncedSearchChange || $[13] !== refine) {
    t9 = event => {
      const value_0 = event?.target?.value ?? "";
      setInputValue(value_0);
      refine(value_0);
      debouncedSearchChange(value_0);
    };
    $[12] = debouncedSearchChange;
    $[13] = refine;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const handleChange = t9;
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <IconSearch color={colorGrayLight2} height={20} />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = `Search ${pageName}`;
  const t12 = inputValue ?? null;
  let t13;
  if ($[16] !== handleChange || $[17] !== t11 || $[18] !== t12) {
    t13 = <LabeledTextInput action={t10} actionAlignment="left" label={t11} labelSize="sm" noMargin={true} onChange={handleChange} value={t12} />;
    $[16] = handleChange;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  return t13;
};
CategorySearchBox.propTypes = {
  pageName: PropTypes.string
};
export default CategorySearchBox;